import styled, { css } from 'styled-components'
import { SearchSpace } from 'src/types/api'
import {
  Noto_body3_m12,
  Noto_body3_r12,
  Noto_desc_r10,
  Noto_subheading_b18,
} from 'src/styles/fonts/NotoSansKrFonts'
import { SearchIsResultProps } from 'src/pages/SearchPage/SearchResultPage'
import RenderIf from 'src/components/common/RenderIf'
import { Spinner } from 'src/components/common/Spinner'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { ellip, mediaMaxWidth } from 'src/styles/mixin'
import LazyImage from 'src/components/common/LazyImage'
import React from 'react'
import { Roboto_num1_b20 } from 'src/styles/fonts/RobotoFonts'
import { getBrandAndCouponName } from 'src/utils'
import Skeleton from 'react-loading-skeleton'

const HasSearchResult = ({
  searchResultList,
  setTarget,
  alwaysCouponDetailPageNav,
  searchResultNoMore,
}: SearchIsResultProps) => {
  const defaultSearchCouponListData = {
    CouponIdx: 0,
    BrandName: '',
    BrandNumber: 0,
    CouponImage: '',
    CouponName: '',
    CouponNumber: '',
    DiscountRate: 0,
    RegularPrice: 0,
    SalePrice: 0,
  }
  const defaultSearchData = Array(12).fill({ ...defaultSearchCouponListData })
  return (
    <S.HasSearchResult.Container $option="flex_column" $row_gap="12px">
      <Typography $fontStyle={Noto_subheading_b18} $color="var(--black-90)">
        검색결과
      </Typography>
      <S.CouponCard.List>
        {(searchResultList?.length === 0 ? defaultSearchData : searchResultList)?.map(
          (ele: SearchSpace.CouponSearchType, index: number) => {
            const { CouponImage, CouponNumber, CouponIdx, CouponName, SalePrice, DiscountRate } =
              ele
            return (
              <S.CouponCard.Items
                key={index}
                $option="flex_column"
                $row_gap="8px"
                onClick={() => alwaysCouponDetailPageNav(CouponNumber, CouponIdx)}
              >
                <S.CouponCard.ImageWrap>
                  <LazyImage src={CouponImage} alt="쿠폰이미지" style={S.CouponCard.Image} />
                </S.CouponCard.ImageWrap>
                <RenderIf when={!SalePrice}>
                  <Skeleton width="100%" count={3} style={{ marginTop: '2px' }} />
                </RenderIf>
                <RenderIf when={!!SalePrice}>
                  <S.CouponCard.TextContainer $option="flex_column">
                    <Container $option="flex_row_wrap" $column_gap="4px">
                      <S.CouponCard.DiscountRate
                        $fontStyle={Roboto_num1_b20}
                        $color="var(--brand-50)"
                      >
                        {Math.floor((DiscountRate as number) * 10) / 10}%
                      </S.CouponCard.DiscountRate>
                      <S.CouponCard.SalePrice $fontStyle={Roboto_num1_b20} $color="var(--black-90)">
                        {SalePrice?.toLocaleString()}원
                      </S.CouponCard.SalePrice>
                    </Container>
                    <S.CouponCard.CouponBrand $fontStyle={Noto_body3_m12} $color="var(--black-90)">
                      {getBrandAndCouponName(CouponName).brandName}
                    </S.CouponCard.CouponBrand>
                    <S.CouponCard.CouponName $fontStyle={Noto_body3_r12} $color="var(--black-90)">
                      {getBrandAndCouponName(CouponName).couponName}
                    </S.CouponCard.CouponName>
                    <S.CouponCard.AlwaysDcChips>상시할인중</S.CouponCard.AlwaysDcChips>
                  </S.CouponCard.TextContainer>
                </RenderIf>
              </S.CouponCard.Items>
            )
          },
        )}
      </S.CouponCard.List>
      <RenderIf when={!searchResultNoMore}>
        <Spinner $color={'var(--black-10)'} ref={setTarget} $margin={'50px auto 0 auto'} />
      </RenderIf>
    </S.HasSearchResult.Container>
  )
}
export default HasSearchResult

const S = {
  HasSearchResult: {
    Container: styled(Container)`
      padding: 0 20px;
      height: 100%;
      margin: 30px 0 50px 0;
    `,
  },
  CouponCard: {
    List: styled(Container)`
      display: grid;
      width: 100%;
      grid-template-columns: repeat(auto-fill, minmax(156px, 1fr));
      ${mediaMaxWidth('360')} {
        grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
      }
      row-gap: 30px;
      grid-column-gap: 8px;
    `,
    Items: styled(Container)`
      width: 100%;
      height: fit-content;
      cursor: pointer;
    `,
    ImageWrap: styled(Container)`
      position: relative;
      height: 0;
      padding-bottom: 100%;
    `,
    Image: css`
      position: absolute;
      top: 0;
      border-radius: 20px;
      outline: 1px solid rgba(0, 0, 0, 0.08);
      padding: 10px;
      width: 100%;
      height: 100%;
      > img {
        border-radius: inherit;
      }
    `,
    TextContainer: styled(Container)``,
    DiscountRate: styled(Typography)``,
    SalePrice: styled(Typography)``,
    CouponBrand: styled(Typography)`
      margin-top: 6px;
    `,
    CouponName: styled(Typography)`
      ${ellip('line2')};
    `,
    AlwaysDcChips: styled.span`
      ${Noto_desc_r10};
      border-radius: 100px;
      border: 1px solid var(--black-10);
      background: var(--black-4);
      padding: 2px 8px;
      margin-top: 6px;
      width: fit-content;
    `,
  },
}
